import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect, useDispatch } from 'react-redux';

import { isInvalidZipcode } from 'Services/HTTPError';

import consultationCategoryProp from 'PropTypes/consultationProps';
import { httpErrorProp } from 'PropTypes/errorProps';

import ZipCode from '../Scenes/ZipCode';

import { fetchCountries as getCountries } from 'dux/countries/actions';
import * as consultationSelectors from 'dux/consultation/selectors';
import { getCountriesList } from 'dux/countries/selectors';
import {
  getHasCompletedOneOfConsultation,
  getUserGeolocationGuessedCountry,
} from 'dux/user/selectors';
import { setZipcode } from 'dux/consultation/thunks';

const ZipCodeComponent = ({
  consultationCategory,
  error,
  getAnswers,
  onNext,
  initialValue,
  fetchCountries,
  geolocationGuessedCountry,
  countriesList,
  ...props
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setSubmitting] = useState(false);
  const countries = countriesList?.map(country => ({ label: country.name, value: country.code }));

  useEffect(() => {
    fetchCountries();
  }, []);

  const saveZipCode = async ({ profile_zipcode, profile_country }) => {
    setSubmitting(true);

    try {
      await dispatch(
        setZipcode({
          answers: getAnswers({ profile_zipcode, profile_country }),
          recover: getAnswers({ ...initialValue }),
        })
      );

      setSubmitting(false);
      onNext();
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <ZipCode
      {...props}
      consultationCategory={consultationCategory}
      countries={countries}
      initialCountryValue={
        initialValue?.profile_zipcode ? initialValue.profile_country : geolocationGuessedCountry
      }
      initialValue={initialValue?.profile_zipcode}
      invalidZipcode={isInvalidZipcode(error)}
      isSaving={isSubmitting}
      onNext={saveZipCode}
      serverError={error}
    />
  );
};

ZipCodeComponent.defaultProps = {
  error: null,
  initialValue: { profile_zipcode: '', profile_country: '' },
  countriesList: undefined,
  hasCompletedOneOfConsultation: false,
};

ZipCodeComponent.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  error: httpErrorProp,
  getAnswers: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  initialValue: PropTypes.shape({
    profile_zipcode: PropTypes.string,
    profile_country: PropTypes.string,
  }),
  fetchCountries: PropTypes.func.isRequired,
  geolocationGuessedCountry: PropTypes.string.isRequired,
  countriesList: PropTypes.arrayOf(PropTypes.object),
  hasCompletedOneOfConsultation: PropTypes.bool,
};

export default connect(
  (state, { consultationCategory, consultationSubsetCategory, questionIndex, routeParams }) => ({
    ...consultationSelectors.getConsultationQuestionForIndex(state, {
      consultationCategory,
      consultationSubsetCategory,
      questionIndex,
      routeParams,
    }),
    error: consultationSelectors.getAggressorsError(state),
    geolocationGuessedCountry: getUserGeolocationGuessedCountry(state),
    countriesList: getCountriesList(state),
    hasCompletedOneOfConsultation: getHasCompletedOneOfConsultation(state),
  }),
  {
    fetchCountries: getCountries,
  }
)(ZipCodeComponent);
